import React from 'react'
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import { Button } from '../styles/Button';


const HeroSection = (props) => {
   
  return (
   <Wrapper>
        <div className='container'>
            <div className='grid grid-two-column'>
                <div className='hero-section-data'>
                    
                    <h2>{props.name}</h2>
                    <p className='intro-data'>Small Changes can makes big Difference! </p>
                    <p> Welcome to CIANA HOME PRODUCTS llp, A merchant exporter of Ceramic Sanitaryware and Bathroom products, 
                      established in 2021 in Gujarat, India. 
                      Our journey began in the wake of the COVID pandemic, 
                      as we recognized the need for reliable and durable sanitary ware in homes and commercial spaces. </p>
                    
                    <NavLink to='/about'>
                        <Button>Show more</Button>

                    </NavLink>
                </div>

                <div className='img-style'>
                        <img  className='img-style' src="images/Feature Image/Hero.jpg" alt="" />
                </div>

            </div>

        </div>

   </Wrapper>
  )
}

const Wrapper=styled.section`
  padding: 12rem 0;  

  .hero-section-data {
    p {
    text-align: justify;
    margin: 2.4rem 0;
    }

  .intro-data {
    margin-bottom: 0;      
    }
  }

  .hero--section-image {
   width: 100%;
   height: auto;
   display: flex;
   justify-content: center;
   align-items: center;
    }
  
  
   figure {
   position: relative;

   &::after {
    content: "";
    width: 60%;
    height: 80%;
    position: absolute;
    left: 50%;
    top: -5rem;
    z-index: -1;
    }
  }
  .img-style {
    width: 100%;
    height: auto;
   }

  @media (max-width: ${({ theme }) => theme.media.mobile}) {
    padding: 2rem 0;

    .grid {
     display:block;
     margin:4%;
     justify-content:justify;
     }

    figure::after {
     content: "";
     width: 50%;
     height: 100%;
     left: 0;
     top: 30%;
     /* bottom: 10%; */
     }
   
    h2{
     font-size : 2.6rem;
     font-weight:500; 
     }
    
    .intro-data {
     font-weight:500; 
     font-style:italic;
      font-size : 1.4rem;
     }
   
    .img-style {
      margin: 2rem 0;
      }
  }
`;

export default HeroSection;
